import {
  FacebookFilled,
  GlobalOutlined,
  InstagramFilled,
  TwitterSquareFilled,
  YoutubeFilled,
} from '@ant-design/icons';
import { ISNS, SNSType } from '@hooks/RentalProperty';
import { Typography } from 'antd';
import { useMemo } from 'react';

type SNSProps = {
  data: ISNS;
};

const SNS: React.FC<SNSProps> = ({ data }) => {
  const icon = useMemo(
    () => ({
      [SNSType.Facebook]: <FacebookFilled />,
      [SNSType.Instagram]: <InstagramFilled />,
      [SNSType.Twitter]: <TwitterSquareFilled />,
      [SNSType.Youtube]: <YoutubeFilled />,
      [SNSType.ExternalURL]: <GlobalOutlined />,
    }),
    [],
  );

  return (
    <a href={data.source} target="_blank" rel="noreferrer">
      <Typography.Text className="sns-icon">{icon[data.type]}</Typography.Text>
    </a>
  );
};

export default SNS;
